import strings from "../res/strings"

const routeConfig = {
  home: {
    title: strings.home,
    path: "/"
  },
  form: {
    title: strings.form,
    path: "/form"
  },
  login: {
    title: strings.login,
    path: "/admin/login"
  },
  listing: {
    title: strings.listing,
    path: "/admin/listing"
  },
  notfound: {
    title: strings.notfound,
    path: "*"
  },
  sandbox: {
    registered: {
      path: "/sandbox/registered",
    },
    confirmed: {
      path: "/sandbox/confirmed",
    },
  }
}
export default routeConfig
